import { PageSizeUnit, PaperType } from 'types/paper.types';

const PAGE_SIZE_CONTENT_WIDTH = 254;

enum Orientation {
  portrait = 'portrait',
  landscape = 'landscape',
}

const initPageSizeMenuState: { unit: PageSizeUnit; orientation: Orientation; isScaled?: boolean } = {
  unit: PageSizeUnit.px,
  orientation: Orientation.portrait,
};

/**
 * Note: this ratio is matching with Venngage editor 1
 */
const PIXEL_TO_INCHES_RATIO: number = 96;

/**
 * Note: this ratio is matching with Venngage editor 1
 */
const PIXEL_TO_CM_RATIO: number = PIXEL_TO_INCHES_RATIO / 2.54;

const MIN_NUMBER_INPUT = 10;
const MAX_NUMBER_INPUT = 8000;
const LONG_PAPER_RATIO = 2.5;
const HD_EXPORT_BREAKPOINT = 3000;

const KEEP_ORIENTATION_PAPERS = [
  PaperType.PRESENTATION,
  PaperType.FACEBOOK,
  PaperType.INSTAGRAM,
  PaperType.LINKEDIN,
  PaperType.PINTEREST,
  PaperType.TWITTER,
];

export {
  MIN_NUMBER_INPUT,
  MAX_NUMBER_INPUT,
  LONG_PAPER_RATIO,
  PAGE_SIZE_CONTENT_WIDTH,
  HD_EXPORT_BREAKPOINT,
  Orientation,
  initPageSizeMenuState,
  PIXEL_TO_INCHES_RATIO,
  PIXEL_TO_CM_RATIO,
  KEEP_ORIENTATION_PAPERS,
};
